import { Hidden, Stack, Text } from 'native-base';

import { Tab } from '~/components/Tabs';

export const EcosystemDownloadFilesHeader = () => {
  return (
    <>
      <Hidden till="lg">
        <Stack flexShrink={0}>
          <Tab
            key="actvities-registered"
            label="Downloads"
            description="Expand your skills with our learning content"
            icon="download-cloud"
            isActive
          />
        </Stack>
      </Hidden>

      <Hidden from="lg">
        <Stack mb={'2'} mt={'2'}>
          <Text fontWeight={500} fontSize={'md'}>
            Downloads
          </Text>
          <Text color={'gray.600'} fontSize={'xs'}>
            Expand your skills with our learning content
          </Text>
        </Stack>
      </Hidden>
    </>
  );
};
